// extracted by mini-css-extract-plugin
export default {"container":"DYK1","header":"qMX7","fields":"JPMF","actions":"wB13","btn":"KaMh","red":"STCW","blue":"nCNP"};